import $ from "jquery";
import ko from "knockout";
import "ulysses/prototype";

"use strict";
var uly = window.uly =  { "actions": {} };
uly.strings = uly.strings || {};
//compat
window.Crimson = window.uly;
window.ko = ko;
window._ = function _(key, default_val) {
    return uly.strings[key] || default_val || key;
};
Promise.whenAll = function (...deferreds) {
    var wrappedDeferreds = [];
    deferreds.forEach((d,idx) => {
        let p = Promise.Deferred();
        wrappedDeferreds.push(p);
        d.then((a)  => {
            p.resolve(a);
        }, (e) => {
            p.resolve(e);
        });
    });
    return Promise.when(...wrappedDeferreds);
};

Promise.when = function (...promises) {
    if (promises.length == 0) {
        return new Promise((r)=>{r();});
    }
    if (promises.length === 1) {
        if (promises[0] && typeof promises[0].then === "function") {
            return promises[0];
        } 
        return new Promise((resolve) => {
            resolve(promises[0]);
        });
    }
    return new Promise((resolve, reject) => {
        var pending = promises.length;
        var results = new Array(pending);
        promises.forEach((d,idx) => {
            d.then((value) => { 
                if (pending > 0) {
                    results[idx] = value;
                    pending--; 
                }
                if (pending===0) {
                    resolve(results); 
                    results = null;
                }
            }, (error) => {
                pending = 0;
                reject(error);
                results = null;
            });
        });
    });
}

export default uly;
